export default "__VITE_ASSET__D7uQ$zFB__"